export class ProcedureBody {
  constructor(
    public readonly isPOE?: boolean,
    public readonly mnemoniqueRef?: string,
    public readonly mnemonique?: string,
    public readonly titre?: string,
    public readonly isSecurite?: string,
    public readonly reference?: string,
    public readonly version?: number,
    public readonly tags?: string[],
    public readonly dateDebutValidite?: string,
    public readonly dateFinValidite?: string,
    public readonly category?: string,
    public readonly mode?: string,
    public readonly type?: string,
    public readonly annexes?: string[],
    public readonly etat?: string,
    public readonly groupeUtilisateurs?: number[],
    public readonly listeUtilisateursIds?: number[],
    public readonly perimetre?: string,
    public readonly contexte?: string,
    public readonly commentaire?: string,
    public readonly prenomCreateur?: string,
    public readonly nomCreateur?: string,
    public readonly emailCreateur?: string,
    public readonly logigramme?: {}
  ) {}
}
